import styleSheet from "./style.module.scss";
import { icon_config, table_content, table_header } from "../admin-config";
import { useSelector } from "react-redux";
import { getImageDetails } from "../../../../../feature/image-slice";
import SyIcon from "../../../../../shared/components/sy-icon";
import { TableProps } from "../admin-interface";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import OrbButton from "../../../../../shared/components/orb-button";
type ModeType = "planets" | "citizens" | "volunteers";
const AdminTableDetals = (props: TableProps) => {
  const { mode, data, onClickAction } = props;
  const imageDetails = useSelector(getImageDetails);
  const [tableData, setOpenTableData] = useState<any>([]);
  const { t } = useTranslation();
  useEffect(() => {
    setOpenTableData(data[mode]);
  }, [data, mode]);

  const getTableHeaders = ({ th_classname, th_name, index }: any) => {
    return (
      <th key={index} className={`${th_classname} text-truncate`} scope="col">
        {t(th_name)}
      </th>
    );
  };

  const getTableContent = ({ data, index }: any) => {
    return (
      <tr key={index} className="lh-lg mohave">
        <td className="px-3 py-2">
          <img
            className={`${styleSheet.image} rounded-circle`}
            src={data?.[table_content[mode].img] || imageDetails.default[0].img}
          />
        </td>
        <td className={` text-truncate sub-font  px-3`}>
          <a
            className={`${styleSheet.name} pointer link ellipsis`}
            onClick={() => onClickAction("visible", mode, data)}
          >
            {data?.[table_content[mode].name]}
          </a>
        </td>
        {mode === "planets" && (
          <>
            <td className="text-truncate">
              <span
                className={`${
                  data?.[table_content[mode].status_id] === 1
                    ? "bg-warning text-dark"
                    : data?.[table_content[mode].status_id] === 2
                    ? "bg-info text-dark"
                    : data?.[table_content[mode].status_id] === 3
                    ? "bg-primary text-white"
                    : data?.[table_content[mode].status_id] === 4
                    ? "bg-success text-white"
                    : "bg-danger text-white"
                }  p-1 rounded opacity-50 font-15`}
              >
                {data?.[table_content[mode].status]}
              </span>
            </td>
            <td className="text-truncate px-3">
              {data?.[table_content[mode].contact_name]}
            </td>
          </>
        )}
        {mode === "citizens" && (
          <td className={`${styleSheet.muted_td} sub-font text-truncate px-3`}>
            <span
              className={`${
                data?.[table_content[mode].status] === 1
                  ? "bg-success text-white"
                  : "bg-danger text-white"
              }  p-1 rounded opacity-50`}
            >
              {data?.[table_content[mode].status] ? "active" : "inactive"}
            </span>
          </td>
        )}

        <td className={`${styleSheet.muted_td} sub-font text-truncate px-3`}>
          {data?.[table_content[mode].email]}
        </td>
        <td className={`${styleSheet.muted_td} sub-font text-truncate px-3`}>
          {data?.[table_content[mode].phone]}
        </td>
        {mode === "planets" ? (
          <>
            <td
              className={`${styleSheet.muted_td} sub-font text-truncate px-3 text-center`}
            >
              <SyIcon
                className="pe-1  pointer opacity-50"
                name={"account_circle"}
                iconStyle="outlined"
                iconColor="green"
                iconType="symbols"
              />
              <span className="badge bg-secondary">{data?.[table_content[mode].citizen]}</span>
            </td>
            <td
              className={`${styleSheet.muted_td} sub-font text-truncate px-3 text-center`}
            >
              <SyIcon
                className="pe-1 pointer opacity-50"
                name={"account_circle"}
                iconColor="yellow"
                iconStyle="outlined"
                iconType="symbols"
              />
               <span className="badge bg-secondary">{data?.[table_content[mode].volunteer]}</span>
            </td>
            <td
              className={`${styleSheet.muted_td} sub-font text-truncate px-3 text-center`}
            >
              <SyIcon
                className="pe-1  pointer opacity-50"
                // name={`${data?.[table_content[mode].volunteer]}? "favorite" : "favorite_border"`}
                name={`favorite`}
                iconColor="red"
                iconType="icons"
              />
               <span className="badge bg-secondary">{data?.[table_content[mode].like]}</span>
              
            </td>
          </>
        ) : (
          <>
            <td className="px-3 py-2 text-center">
              {data?.[table_content[mode].planet] && (
                <img
                  className={`${styleSheet.image} rounded-circle`}
                  src={data?.[table_content[mode].planet]}
                />
              )}
            </td>
            <td className={` text-truncate sub-font  px-3`}>
              <a
                className={`${styleSheet.name} pointer link ellipsis`}
                onClick={() => onClickAction("planet_visible", mode, data)}
              >
                {data?.[table_content[mode].planet_name]}
              </a>
            </td>
          </>
        )}
        {mode === "volunteers" && (
          <td className="px-3 py-2">
            {!data?.[table_content[mode].citizen]&&
            <OrbButton
              iconName="person_add_alt"
              iconColor="green"
               className="font-15 p-0"
            
              type="submit"
              value={mode}
              onBtnClick={() => onClickAction('add_citizen', mode, data)}
              label={"Add Citizen"}
            />}
          </td>
        )}
        <td className="px-3">
       

          {icon_config[mode]
            ?.filter((icon: any) => {
              if (mode === "citizens") {
                if (
                  data?.[table_content[mode].user_type] === 1 &&
                  (icon.value === "add" || icon.value === "remove")
                ) {
                  return false;
                }
                if (
                  data?.[table_content[mode].user_type] != 1 &&
                  data?.[table_content[mode].status] &&
                  icon.value === "add"
                ) {
                  return false;
                }
                if (
                  data?.[table_content[mode].user_type] != 1 &&
                  !data?.[table_content[mode].status] &&
                  icon.value === "remove"
                ) {
                  return false;
                }
                return true;
              }
              if (mode === "volunteers") {
                if (!data?.[table_content[mode].like] && icon.value === "like" ) {
                  return false;
                } else if(data?.[table_content[mode].like] && icon.value === "un_like"){
                  return false;
                }else{
                  return true;
                }

              }
              return true;
            })
            .map((icon: any) => (
              <SyIcon
                name={icon.name}
                className={"opacity-50 ms-2 pointer"}
                iconType={icon.iconType}
                iconColor={icon?.iconColor}
                onClick={() => onClickAction(icon?.value, mode, data)}
              />
            ))}
        </td>
      </tr>
    );
  };

  return (
    // <table className={`${styleSheet.table_style} w-100 `}>
    //   <thead className="lh-lg">
    //     <tr>
    //       {table_header[mode].map((data: any, index: number) =>
    //         getTableHeaders({ ...data, index: index })
    //       )}
    //     </tr>
    //   </thead>
    //   <tbody className="position-relative overflow-scroll">
    //     {tableData?.length ? (
    //       tableData?.map((data: any, index: number) =>
    //         getTableContent({ data, index: index })
    //       )
    //     ) : (
    //       <div className=" position-absolute position-absolute mt-5 end-50">
    //         <p>{t('no_data_found')}</p>
    //       </div>
    //     )}
    //   </tbody>
    // </table>

    <table
      className={`${styleSheet.table_style} text-white  w-100 overflow-scroll  `}
    >
      <thead className="lh-lg position-sticky">
        <tr>
          {table_header[mode].map((data: any, index: number) =>
            getTableHeaders({ ...data, index: index })
          )}
        </tr>
      </thead>
      <tbody className="">
        {tableData?.length ? (
          tableData?.map((data: any, index: number) =>
            getTableContent({ data, index: index })
          )
        ) : (
          <div className=" position-absolute position-absolute mt-5 end-50">
            <p>{t("no_data_found")}</p>
          </div>
        )}
      </tbody>
    </table>
  );
};

export default AdminTableDetals;
